export default __webpack_public_path__ + "static/media/icon-WETH.376fdfed.svg";